import React  from 'react';
import './App.css';
import './Notebook.css';
import { PiDotsThreeVertical } from "react-icons/pi";
import NotebookLang from './NotebookLang.json';

import SourceDotsPopup from './SourceDotsPopup.js';
import SourceDeletePopup from './SourceDeletePopup.js';

class NotebookSourceList extends React.Component {
	
	constructor(props) {

		super(props);

		this.state = {
			dotsSourceID: 0,
			dotsSourceIndex: -1,
			sourceDotsPopupYN: false,
			sourceDeletePopupYN: false,
		}

		this.refreshData = this.refreshData.bind(this);
		this.setSourceDotsPopupYN = this.setSourceDotsPopupYN.bind(this);
		this.setSourceDeletePopupYN = this.setSourceDeletePopupYN.bind(this);
	}
	
	refreshData() {
		this.props.refreshData();
	}
		
	setSourceDotsPopupYN(sourceDotsPopupYN) {
		this.setState({
			sourceDotsPopupYN: sourceDotsPopupYN,
		});
	}
	
	setSourceDeletePopupYN(sourceDeletePopupYN) {
		this.setState({
			sourceDeletePopupYN: sourceDeletePopupYN,
		});
	}
	
	onMouseMove(event) {
		var mouseX = event.clientX;
		var mouseY = event.clientY;
		if (this.state.sourceDotsPopupYN) {
			return;
		}
		this.setState({
			mouseX: mouseX,
			mouseY: mouseY,
		});
	}

	getExtFromFilename(filename) {
		var ext = filename.substr(filename.lastIndexOf('.') + 1);
		return ext.toLowerCase();
	}

	onClickSource(index, filenameExt) {

		var notebookJsonObj = this.props.notebookJsonObj;
		var storageID = notebookJsonObj.storageID;

		var ext = this.getExtFromFilename(filenameExt);
		
		if (ext === "txt") {
			this.props.setSourceIndex(index);
			this.props.setNotebookPasteTextPopupYN(true);
		} else {
			var url = "https://storage.googleapis.com/" + storageID + "/" + filenameExt;
			window.open(url, '_blank', 'noopener,noreferrer');
		}
	}
	
	onClickAddSources() {
		var userSettingsJsonObj = this.props.userSettingsJsonObj;
		if (userSettingsJsonObj === null) {
			return;
		}
		var geminiAPIKey = userSettingsJsonObj.geminiAPIKey;
		geminiAPIKey = geminiAPIKey.trim();
		
		if (geminiAPIKey === "") {
			var toastString = this.props.getLang(NotebookLang, "geminiAPIKeyIsEmpty");
			this.props.showToast(toastString);
			return;
		}
		
		this.props.setNotebookAddSourcePopupYN(true);
		this.props.setSourceIndex(-1);
 	}
	
	onClickDots(sourceIndex, sourceID) {
		this.setState({
			dotsSourceID: sourceID,
			dotsSourceIndex: sourceIndex,
		});
		this.setSourceDotsPopupYN(true);
	}
	
	renderOneSource(index, itemObj) {
		
		var key = "source-" + index;
		var sourceID = itemObj.sourceID;
		var filename = itemObj.filename;

		var notebookJsonObj = this.props.notebookJsonObj;
		var displayDotsYN = true;

		return (
			<div key={key}>
				<div className="NotebookSourceListFilenameContainer">
					<div className="NotebookSourceListFilenameItem" onClick={() => this.onClickSource(index, filename)}>{filename}</div>
					{displayDotsYN && (
						<div className="NotebookSourceListDotsItem" onClick={() => this.onClickDots(index, sourceID)}>				  
							<PiDotsThreeVertical style={{ width: "25px", height: "20px" }} />
						</div>)}
				</div>
				<div style={{height: "5px"}}></div>
			</div>
		);
	}
	
	renderAllSources() {

		var sourceArray = this.props.sourceArray;
		if (sourceArray === null) {
			return;
		}

		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<sourceArray.length; i++) {
			itemObj = sourceArray[i];
			jsxCode = this.renderOneSource(i, itemObj);
			jsxArray.push(jsxCode);
		}

		if (sourceArray.length > 0) {
			return (
				<div>
					{jsxArray}
					<hr className="NotebookCustomLine" />
				</div>
			);
		}
		
		return jsxArray;
	}
	
	renderSourceDotsPopup() {
		return (
			<SourceDotsPopup
				renderPopupYN={this.state.sourceDotsPopupYN}
				positionX={this.state.mouseX}
				positionY={this.state.mouseY}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				sourceID={this.state.dotsSourceID}
				sourceIndex={this.state.dotsSourceIndex}
				sourceArray={this.props.sourceArray}
				ownerYN={this.props.ownerYN}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				setSourceIndex={this.props.setSourceIndex}
				setSourceDotsPopupYN={this.setSourceDotsPopupYN}
				setSourceDeletePopupYN={this.setSourceDeletePopupYN}
			/>
		);
	}
		
	renderSourceDeletePopup() {

		var sourceArray = this.props.sourceArray;
		var dotsSourceIndex = this.state.dotsSourceIndex;
		if (dotsSourceIndex < 0) {
			return;
		}
		var sourceJsonObj = sourceArray[dotsSourceIndex];

		return (
			<SourceDeletePopup
				renderPopupYN={this.state.sourceDeletePopupYN}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				notebookJsonObj={this.props.notebookJsonObj}
				sourceID={this.state.dotsSourceID}
				sourceJsonObj={sourceJsonObj}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				setSourceDeletePopupYN={this.setSourceDeletePopupYN}
				refreshData={this.refreshData	}
			/>
		);
	}
		
	render() {
		
		var displayAddSourceButtonYN = false;
		if (this.props.ownerYN) {
			displayAddSourceButtonYN = true;
		}

		return (
			<div className="NotebookSourceListTopContainer" onMouseMove={(event) => {this.onMouseMove(event)}}>
				{this.renderSourceDotsPopup()}
				{this.renderSourceDeletePopup()}
				<div style={{height: "12px"}}></div>
				<div className="NotebookSourceTitle">{this.props.getLang(NotebookLang, "sources")}</div>
				<hr className="NotebookCustomLine" />
				{this.renderAllSources()}
				<div style={{height: "20px"}}></div>
				{displayAddSourceButtonYN && (
					<button className="ViewSaveButton" onClick={() => this.onClickAddSources()}>{this.props.getLang(NotebookLang, "addSources")}</button>
				)}
				<div style={{height: "12px"}}></div>
			</div>
		);
	}
}

export default NotebookSourceList;

